import { addLocaleData } from 'react-intl';
import it from 'react-intl/locale-data/it';
import navLocaleData from '@99designs/common/apps/global-nav/locale-data/it';
import { setTranslations as setNavTranslations } from '@99designs/common/apps/global-nav/locale-data';

setNavTranslations(navLocaleData);
addLocaleData(it);



// WEBPACK FOOTER //
// ./src/js/locale-data/it.js